import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';
import { ArrowLeft } from 'styled-icons/feather';
import Link from 'next/link';

const Content = styled.a`
  ${({ theme }) => css`
    display: block;
    margin-bottom: 1em;
    color: ${theme.colors.brand.accent};

    &:hover, &:active {
      cursor: pointer;
      color: ${theme.colors.brand.accent};
    }
  `};
`;

const BackArrow = styled(ArrowLeft)`
  height: 1.4em;
  width: 1.4em;
  line-height: 1.4em;
`;

const BackLink = ({ href, className, children, style }) => {
  const router = useRouter();
  const handleClick = event => {
    if (!!href && typeof href === 'string') {
      const target = (href.includes('bidali.com') || href.charAt(0) === '/')
        ? '_self'
        : '_blank';

      if (target === '_self') {
        router.push(href);
      } else {
        window.open(href, target);
      }
    } else {
      router.back();
    }
  };
  
  children = !children ? 'Back' : children;
  
  return (
      <Link href={href} onClick={handleClick} style={style} className={className}>
        <Content>
          <BackArrow strokeWidth={2}/>
          {children}
        </Content>
      </Link>
  );
};


BackLink.defaultProps = {
  href: ''
};

export default BackLink;
  